import { useState } from 'react';
import { InternalSearchFilter, InternalSearchFilterKeys } from '../types';

interface UseFilterSelectionReturn {
  selectedFilters: InternalSearchFilter;
  setSelectedFilter: (type: InternalSearchFilterKeys, value: string) => void;
  clearAllFilters: () => void;
}

export const useFilterSelection = (): UseFilterSelectionReturn => {
  const [selectedLicenses, setSelectedLicenses] = useState<string[]>([]);
  const [selectedPublishingModels, setSelectedPublishingModels] = useState<
    string[]
  >([]);
  const [selectedPayments, setSelectedPayments] = useState<string[]>([]);
  const [selectedImprints, setSelectedImprints] = useState<string[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<string[]>([]);

  const setSelectedFilter = <K extends InternalSearchFilterKeys>(
    type: K,
    value: string
  ) => {
    const setters = {
      licenses: setSelectedLicenses,
      publishingModels: setSelectedPublishingModels,
      payments: setSelectedPayments,
      imprints: setSelectedImprints,
      statuses: setSelectedStatus,
    };

    const setter = setters[type];

    setter((currentArray) => {
      if (currentArray.indexOf(value) === -1) {
        return [...currentArray, value];
      } else {
        const newArray = [...currentArray];
        newArray.splice(newArray.indexOf(value), 1);
        return newArray;
      }
    });
  };

  const clearAllFilters = () => {
    setSelectedLicenses([]);
    setSelectedPublishingModels([]);
    setSelectedPayments([]);
    setSelectedImprints([]);
    setSelectedStatus([]);
  };

  return {
    selectedFilters: {
      licenses: selectedLicenses,
      publishingModels: selectedPublishingModels,
      payments: selectedPayments,
      imprints: selectedImprints,
      statuses: selectedStatus,
    },
    setSelectedFilter,
    clearAllFilters,
  };
};
